import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

let changePasswordValidationForm = yup.object().shape({
  password: yup.string().required("Password is required"),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords don't match!")
    .required("Required"),
});

let forgetPasswordValidationForm = yup.object().shape({
  email: yup.string().email().required("Email is required"),
});

let createUserServiceValidationForm = yup.object().shape({
  username: yup
    .string()
    .required("Username is required")
    .min(3, "Username must be at least 3 characters")
    .max(20, "Username must be at most 20 characters")
    .matches(
      /^[a-zA-Z0-9_]+$/,
      "Username can only contain letters, numbers, and underscores"
    )
    .notOneOf(["admin", "root", "superuser"], "This username is not allowed"),
  full_name: yup.string().required("Full Name is required"),
  email: yup.string().email().required("Email is required"),
  alt_email: yup
    .string()
    .transform((value) => (!value ? null : value))
    .optional()
    .nullable(),
  mobile_number: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),

  branch: yup.string().uuid().required("Please select a branch"),
});

let updateLoginLimitValidationForm = yup.object().shape({
  allowed_desktop_login: yup
    .number()
    .required("required")
    .typeError("Value must be a number"),
  allowed_mobile_login: yup
    .number()
    .required("required")
    .typeError("Value must be a number"),
});

let updateUserValidationForm = yup.object().shape({
  username: yup
    .string()
    .required("Username is required")
    .min(3, "Username must be at least 3 characters")
    .matches(
      /^[a-zA-Z0-9_]+$/,
      "Username can only contain letters, numbers, and underscores"
    )
    .notOneOf(["admin", "root", "superuser"], "This username is not allowed"),
  full_name: yup.string().required("Full Name is required"),
  email: yup.string().email().required("Email is required"),
  address_name: yup
    .string()
    .transform((value) => (!value ? null : value))
    .optional()
    .nullable(),
  alt_email: yup
    .string()
    .transform((value) => (!value ? null : value))
    .optional()
    .nullable(),
  mobile_number: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  alt_mobile_number: yup
    .string()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "" || /^\+\d{1,4}$/.test(value.trim())) {
        return true;
      }
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
  branch: yup.string().uuid().required("Please select a branch"),
});

let userProfileValidationForm = yup.object().shape({
  full_name: yup.string().required("Full Name is required"),
  email: yup.string().email().optional().nullable(),
  contact_number: yup
    .string()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "" || /^\+\d{1,4}$/.test(value.trim())) {
        return true;
      }
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
});
let bankDetailsValidationForm = yup.object().shape({
  beneficiary: yup.string().required("Name is required"),
  bank_name: yup.string().required("Bank Name is required"),
  account_number: yup.string().required("Account No. is required"),
  address: yup.string().required("Address is required"),
  code: yup.string().required("Swift Code is required"),
});

let branchValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
  company_name: yup.string().required("Company Name is required"),
  primary_email: yup.string().email().required("Primary Email is required"),
  secondary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  landmark: yup.string().required("Full Address is required"),
  vat_pan: yup.string().required("VAT/PAN is required"),
  code: yup.string().required("Code is required"),
});

let createStaffValidationForm = yup.object().shape({
  user: yup.string().required("User is required"),
  designation: yup.string().required("Designation is Required"),
});
const editStaffValidationForm = yup.object().shape({
  name: yup.string().required("Full Name is required"),
  mobile_number: yup
    .string()
    .required("Mobile Number is required")
    .matches(
      /^[0-9]{10,15}$/,
      "Mobile Number must be between 10 and 15 digits"
    ),
  email: yup.string().email("Invalid Email").nullable(),
  default_branch: yup.string().uuid().required("Please select a branch"),
});
const createUserValidationForm = {
  user: yup
    .mixed()
    .required("Please select a user")
    .test("is-valid-user", "Invalid user", (value) => {
      if (!value) return false;
      if (typeof value === "object" && "id" in value) return true;
      if (typeof value === "string" && value.trim() !== "") return true;
      return false;
    }),
};

export {
  changePasswordValidationForm,
  forgetPasswordValidationForm,
  branchValidationForm,
  createUserServiceValidationForm,
  updateUserValidationForm,
  userProfileValidationForm,
  bankDetailsValidationForm,
  updateLoginLimitValidationForm,
  createStaffValidationForm,
  createUserValidationForm,
  editStaffValidationForm,
};
